import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import "../../../constants/index.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import "../../../assets/IconSpinner.js";
import { useState, useEffect, useCallback } from "react";
import SvgArrowDown from "../../../assets/vuesax/arrow-down.svg.js";
import Drawer from "../../utils/Drawer/Drawer.js";
import DrawerTitle from "../../utils/DrawerTitle/DrawerTitle.js";
import SelectOptions from "../SelectOptions/SelectOptions.js";
const LanguageSelector = ({
  classes,
  className,
  variant = "ghost",
  size = "md",
  value,
  defaultValue,
  onChange,
  placeholder = "Languages",
  title = "Languages",
  languages,
  closeOnSelect = true
}) => {
  const { themeClasses } = useThemePresetClasses("LanguageSelector", classes, className, {
    variant,
    modifier: size
  });
  const [langValue, setLangValue] = useState(defaultValue);
  const [isShowOptions, setIsShowOptions] = useState(false);
  useEffect(() => {
    if (value) {
      setLangValue(value);
    }
  }, [value]);
  const handleOnChange = (value2) => {
    onChange && onChange(value2);
    if (closeOnSelect) {
      handleCloseOptions();
    }
  };
  const handleCloseOptions = useCallback(() => {
    setIsShowOptions(false);
  }, []);
  const handleOpenOptions = useCallback(() => {
    setIsShowOptions(true);
  }, []);
  const handleOnSelect = (lang) => {
    setLangValue(lang);
    handleOnChange(lang);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "button",
      {
        onClick: handleOpenOptions,
        className: cn(themeClasses == null ? void 0 : themeClasses.root),
        children: [
          !!langValue && /* @__PURE__ */ jsxs("span", { className: "flex items-center", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: langValue.flagURL,
                alt: langValue == null ? void 0 : langValue.name,
                className: cn("flex-shrink-0", themeClasses == null ? void 0 : themeClasses.flag)
              }
            ),
            /* @__PURE__ */ jsx("span", { className: cn("mx-2 line-clamp-1 block text-ellipsis whitespace-nowrap", themeClasses == null ? void 0 : themeClasses.label), children: langValue.name })
          ] }),
          !langValue && /* @__PURE__ */ jsx(
            "span",
            {
              className: cn("line-clamp-1 block text-ellipsis whitespace-nowrap pl-2 text-center", themeClasses == null ? void 0 : themeClasses.label),
              children: placeholder
            }
          ),
          /* @__PURE__ */ jsx(SvgArrowDown, { className: cn("ml-auto flex-shrink-0", themeClasses == null ? void 0 : themeClasses.arrow) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      Drawer,
      {
        open: isShowOptions,
        onClose: handleCloseOptions,
        placement: "bottom",
        children: [
          /* @__PURE__ */ jsx(DrawerTitle, { title }),
          /* @__PURE__ */ jsx(
            SelectOptions,
            {
              className: "mx-8 mb-6 mt-6",
              options: languages.map((lang) => ({ id: lang.code, imgUrl: lang.flagURL, name: lang.name })),
              selectedOption: langValue && {
                id: langValue.code,
                imgUrl: langValue.flagURL,
                name: langValue.name
              },
              imageVariant: "circular",
              handleOnSelect: (option) => handleOnSelect({
                code: option.id,
                name: option.name ?? "",
                flagURL: option.imgUrl ?? ""
              })
            }
          )
        ]
      }
    )
  ] });
};
const LanguageSelector$1 = LanguageSelector;
export {
  LanguageSelector$1 as default
};
